import { Card } from "../../components/Card";
import { RECEIPT_BONUS_PERCENT } from "./constants";

export function BonusesActionCards({ isAdmin, onOpenAdd, onOpenDeduct, onScanQr }) {
  return (
    <div className="cardsGrid">
      {isAdmin ? (
        <Card
          variant="light"
          title="Добавить бонусы"
          subtitle={`${RECEIPT_BONUS_PERCENT}% от суммы чека по QR`}
          inactive={false}
          onClick={onOpenAdd}
        />
      ) : null}
      {isAdmin ? (
        <Card
          variant="light"
          title="Списать бонусы"
          subtitle="QR спишет бонусы с гостя"
          inactive={false}
          onClick={onOpenDeduct}
        />
      ) : null}
      <Card
        variant="light"
        title="Сканировать QR"
        subtitle={
          isAdmin
            ? "Начисление или списание по коду другого админа"
            : "Отсканируйте QR и получите бонус, ну или потратьте бонусы"
        }
        inactive={false}
        onClick={onScanQr}
        className={isAdmin ? "card--span2" : "card--span2 card--guestScan"}
      />
    </div>
  );
}
